import useServiceType from '@/hooks/useServiceType';
import alertState from '@/states/alertState';
import { Constants } from '@/utils/constants';
import { useRouter } from 'next/router';
import { useRecoilState } from 'recoil';
import Button from '../atoms/Button';
import SystemErrorMessage from '../atoms/SystemErrorMessage';

/**
 * API エラー発生時に共通メッセージを表示し、必要なら安全な一覧画面へ戻す共通ダイアログ。
 * 取得系エラー後に同じ画面へ留めると表示破綻しやすいため、サービス種別ごとのトップへ退避させる。
 */
const AlertDialog = () => {
  const [alert, setAlert] = useRecoilState(alertState);

  // hooks
  const router = useRouter();
  const serviceType = useServiceType();

  const onClose = () => {
    const apiTypeValue = alert.apiType;
    setAlert({
      isOpen: false,
      apiType: '',
    });
    // 初期表示に必要な取得 API 失敗時だけは、継続表示せずトップへ戻して再導線する。
    if (apiTypeValue === Constants.ApiType.API_GET) {
      if (serviceType === 'fixed') {
        router.push('/top');
      } else if (serviceType === 'mobile') {
        router.push('/mobile/top');
      }
    }
  };

  const setMessage = () => {
    // API 種別ごとに利用者向け文言を切り替え、必要な案内だけを見せる。
    switch (alert.apiType) {
      case Constants.ApiType.OPTION_CHANGE:
        return Constants.ErrorDialogMessage.OPTION_CHANGE;
      default:
        return Constants.ErrorDialogMessage.DEFAULT;
    }
  };

  if (alert.isOpen) {
    if (typeof window === 'object') {
      // 背面操作を止めて、エラー確認と復帰導線の選択を優先させる。
      document.body.style.overflow = 'hidden';
    }
    return (
      <>
        <div className='m-modal js-modal is-modal-fade is-modal-show alert-dialog'>
          <div className='m-modal__inner'>
            <div className='m-modal__content align-center'>
              <div className='text-alert'>ご確認ください</div>
              <SystemErrorMessage message={setMessage()} />
            </div>
            <div className='m-modal__footer'>
              <div className='m-button align-center'>
                <Button variant='secondary' onClick={onClose}>
                  OK
                </Button>
              </div>
            </div>
          </div>
        </div>
        <span
          role='button'
          tabIndex={0}
          className='fn-overlay is-overlay-show'
          onClick={onClose}
          onKeyDown={onClose}
          aria-label='閉じる'
          data-testid='show'
        />
      </>
    );
  }
  if (typeof window === 'object') {
    document.body.style.overflow = '';
  }

  return <span className='fn-overlay' data-testid='hidden' />;
};

export default AlertDialog;
